import gql from 'graphql-tag';
import {useQuery} from './query';
import {
  FeaturedReportsQueryVariables,
  FeaturedReportsQuery,
  FeaturedReportsDocument,
} from '../../generated/graphql';

import * as ApolloReactHooks from '@apollo/react-hooks';

export const REPORT_ADMIN_BAR_QUERY = gql`
  query FeaturedReports {
    featuredReports {
      id
      spec
    }
  }
`;

export const useFeaturedReportsQuery = (
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FeaturedReportsQuery,
    FeaturedReportsQueryVariables
  >
) => {
  return useQuery<FeaturedReportsQuery, FeaturedReportsQueryVariables>(
    FeaturedReportsDocument,
    baseOptions ?? {}
  );
};

export const UPDATE_FEATURED_REPORTS_QUERY = gql`
  mutation UpdateFeaturedReports($id: ID, $spec: String!) {
    upsertView(
      input: {id: $id, spec: $spec, name: "", type: "featuredReports"}
    ) {
      view {
        id
        updatedAt
        createdAt
        spec
      }
      inserted
    }
  }
`;

export const PROJECT_ACCESSES_QUERY = gql`
  query ProjectAccess($name: String, $entityName: String) {
    project(name: $name, entityName: $entityName) {
      id
      access
    }
  }
`;
